import { Box, Paper, Tab, Tabs, useTheme } from "@mui/material";
import React, { Fragment, SetStateAction, useState } from "react";
import useStyles from "./styles";
import GraphicsCard from "./graphicsComponent";
import { Stack } from "@mui/system";
import ExecuteQuery from "../editorMenu/executeQuery";

interface GraphicConfigMenuProps {
  card: DashCardsGraphics | undefined;
  graphic: DashGraphicsCards | undefined;
  updateCard: (newCard: DashCardsGraphics) => void;
  handleUpdateGraphic: (newGraphic: DashGraphicsCards) => void;
  setResultQuery: React.Dispatch<SetStateAction<any[]>>;
  setErrorQuery: React.Dispatch<SetStateAction<string>>;
  setLoading: React.Dispatch<SetStateAction<boolean>>;
  pageId: string;
}

const GraphicConfigMenu: React.FC<GraphicConfigMenuProps> = ({
  graphic,
  card,
  handleUpdateGraphic,
  setResultQuery,
  setErrorQuery,
  setLoading,
  pageId,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [tabValue, setTabValue] = useState(graphic?.type === "repeat" ? 1 : 0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box
      sx={{
        marginX: 1,
        padding: 1,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        borderRadius: "1rem",
        height: "100%",
      }}
    >
      <Tabs sx={{ height: "5%" }} value={tabValue} onChange={handleTabChange}>
        <Tab
          disableRipple
          disableFocusRipple
          label="Executar query"
          value={0}
          disabled={graphic?.type === "repeat"}
        />
        <Tab
          disableRipple
          disableFocusRipple
          label="Configurações do gráfico"
          value={1}
        />
      </Tabs>
      {tabValue === 0 && (
        <Stack
          sx={{
            height: "95%",
            gap: 2,
          }}
        >
          <ExecuteQuery
            data={graphic}
            initialQuery={graphic?.query}
            setResultQuery={setResultQuery}
            setErrorQuery={setErrorQuery}
            setLoading={setLoading}
            handleUpdateGraphic={handleUpdateGraphic}
            pageId={pageId}
          />
        </Stack>
      )}

      {tabValue === 1 && (
        <Fragment key={graphic.id}>
          <GraphicsCard
            id={graphic.id}
            key={graphic.id}
            data={graphic}
            isSplit={!!card?.split}
            handleUpdateGraphic={handleUpdateGraphic}
          />
        </Fragment>
      )}
    </Box>
  );
};

export default GraphicConfigMenu;
